import { LanguageType } from '../../@types';
import { useSkin } from '../../contexts/SkinContext';
import { SKIN } from '../../types/enums';

const BET365_MENU_FIELDS = ['language', 'userList', 'accountBalance', 'createNewUser', 'logout'];
const GOLA_MENU_FIELDS = ['userList', 'accountBalance', 'createNewUser', 'changePassword', 'messages', 'logout'];
const NEOBET_MENU_FIELDS = [
  'language',
  'userList',
  'accountBalance',
  'createNewUser',
  'changePassword',
  'messages',
  'logout',
];

const skinnedMenuFields = {
  [SKIN.BET365]: BET365_MENU_FIELDS,
  [SKIN.GOLA]: GOLA_MENU_FIELDS,
  [SKIN.NEOBET]: NEOBET_MENU_FIELDS,
};

export const useAccountMenuFields = () => {
  const { skin } = useSkin();
  const accountMenuFieldKeys = skinnedMenuFields[skin] || [];
  const getMenuFields = (
    handleMenuItemClick: (arg0?: string) => void,
    openRegisterBOUserForm: () => void,
    handleLanguageChange: (value: LanguageType) => Promise<void>,
    handleLogoutClick: () => void
  ) => {
    return accountMenuFieldKeys.map((field) => ({
      key: field,
      action: async (value?: LanguageType) => {
        switch (field) {
          case 'language':
            if (value) {
              await handleLanguageChange(value);
            }
            break;
          case 'userList':
            handleMenuItemClick('/user-list');
            break;
          case 'accountBalance':
            handleMenuItemClick('/account-balance');
            break;
          case 'createNewUser':
            openRegisterBOUserForm();
            handleMenuItemClick();
            break;
          case 'changePassword':
            handleMenuItemClick('/change-password');
            break;
          case 'messages':
            handleMenuItemClick('/my-account/messages/inbox');
            break;
          case 'logout':
            handleLogoutClick();
            break;
          default:
            handleMenuItemClick();
        }
      },
    }));
  };

  return {
    getMenuFields,
  };
};
